module.exports = __webpack_public_path__ + "img/portfolio-02.15d2fd86.jpg";